import { Fiat, Offer, PriceAlert } from "@models";
import { AfterViewInit, Directive, inject, Input } from "@angular/core";
import { Router } from "@angular/router";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { Tradable } from "@models/interfaces/tradable";
import { MODAL_ANIMATION_TIMEOUT } from "@helpers/constants";
import { PricewatchAddModalComponent } from "@modules/shared/modals/pricewatch-add-modal/components/pricewatch-add-modal.component";
import { AccountService } from "@modules/account/services/account.service";
import { FiatService } from "@main-services/currency";
import { SegmentService } from "@main-services/segment.service";
import { CustomModal } from "@modules/core/components/base-modals";
import { CashplusNavigationService } from "@modules/cashplus/infrastructure/cashplus-navigation.service";
import { CashPlusRouteName } from "@modules/cashplus/entities/cashplus.navigation.model";
import { CashPlusTrackingFacade } from "@modules/cashplus/+state/cashplus-tracking.facade";
import { RudderstackService } from "@main-services/rudderstack.service";

@Directive({
	providers: [CashPlusTrackingFacade],
	standalone: false
})
export abstract class SuccessComponent extends CustomModal implements AfterViewInit {
	@Input()
	public offer: Offer = null;

	private cashPlusNavigation = inject(CashplusNavigationService);
	private cashPlusTrackingFacade = inject(CashPlusTrackingFacade);

	protected flowName: string = "";
	protected pathPrepend: string = "";

	protected constructor(
		protected fiatService: FiatService,
		protected tradableListService: TradableListService,
		protected accountService: AccountService,
		protected router: Router,
		protected segmentService: SegmentService,
		protected rudderstackService: RudderstackService
	) {
		super();
	}

	public ngAfterViewInit(): void {
		if (this.flowName) {
			this.segmentService.page({
				name: `${this.flowName} Success`,
				overridePath: `${this.pathPrepend}/success`
			});
			this.rudderstackService.page({
				name: `${this.flowName} Success`,
				overridePath: `${this.pathPrepend}/success`
			});
		}
	}

	public getTradable(coinId: string = this.offer.getCurrencyId()): Tradable {
		return this.tradableListService.getItemById(coinId);
	}

	public getFiat(): Fiat {
		return this.fiatService.getItemById(this.offer.getFiatId());
	}

	public getDefaultFiat(): Fiat {
		return this.accountService.getDefaultFiat();
	}

	public save(): void {
		// Nothing
	}

	// TODO: eslint fix
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	public close(role?: string, data: any = null): void {
		this.modalService.pop(data, role);
	}

	public goToWallet(): void {
		this.close();
		setTimeout(() => {
			// The Backbutton handling in Modals screws this if you dont delay it a little
			const walletRoute = this.offer.isIndexTrade() ? "/index-wallet/" : "/wallet/";
			this.router.navigateByUrl(walletRoute + this.offer.getWalletId());
		}, MODAL_ANIMATION_TIMEOUT);
	}

	public gotoDiscoverCashPlus(): void {
		this.cashPlusTrackingFacade.discoverCashPlusClicked("Sell successful");
		this.close();
		this.cashPlusNavigation.gotoByNavigationUrl(CashPlusRouteName.Intro);
	}

	public goToPortfolio(): void {
		this.close();
		setTimeout(() => {
			this.router.navigateByUrl("/portfolio");
		}, MODAL_ANIMATION_TIMEOUT);
	}

	public addPriceAlert(currencyId: string = this.offer.getCurrencyId()): void {
		this.close();
		const p = new PriceAlert();
		p.setCurrencyId(currencyId);
		p.setFiatId(this.getDefaultFiat().getId());
		this.modalService.create(PricewatchAddModalComponent, { data: p }, { showCloseButton: true }).present();
	}
}
